import { call, put } from 'redux-saga/effects';
import { apiGeneral, notify } from 'services';
import { IUpdateRequest } from 'interfaces/update-duck';
import { requestErrorHandler } from 'utils';
import { UpdateRegionalActions } from 'store/ducks/settings/regional';

export function* updateRegionalRequest(action: any) {
  try {
    const { id, putData, onSuccess } = action as IUpdateRequest;

    const { data: responseBody } = yield call(
      apiGeneral.put,
      `/regional/${id}`,
      putData
    );

    const { data } = responseBody;
    yield put(UpdateRegionalActions.success(data));
    notify('success', 'Regional atualizado com sucesso');
    if (onSuccess) onSuccess();
  } catch (error) {
    const { errorMessage } = requestErrorHandler(error);
    notify('error', errorMessage);
    yield put(UpdateRegionalActions.failure(errorMessage));
  }
}
